import {unitsModule} from "./unitsModule";
import {IStateProvider} from "angular-ui-router";

unitsModule.config(($stateProvider: IStateProvider) => {
    $stateProvider.state("r2.units", {
        data: {
            pageTitle: "{{'title.r2.units' | translate}}",
            group: "group.r2.units"
        },
        url: "/units",
        template: require("./units.html"),
        controller: "unitsController",
        controllerAs: "ctrl",
    })
})